import { createStyle } from '@gluestack-style/react';

export const PopoverHeader = createStyle({
  p: '$4',
  pb: '$2',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexDirection: 'row',
});
